import React from "react";
import { PlaintextTypes } from "../../../types/ContentCard";
import { PlaintextP } from "./PlaintextStyles";

const Plaintext: React.FC<{
  contentCardData: PlaintextTypes;
}> = ({ contentCardData }) => {
  return (
    <PlaintextP data-sm-content="plaintext">
      {contentCardData.data.text}
      {contentCardData.data.link && (
        <a href={contentCardData.data.link} target="_blank">
          {contentCardData.data.linkText}
        </a>
      )}
    </PlaintextP>
  );
};

export default Plaintext;
